<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="uFghY3E9oG7VYoqgE67JhN2">
<p class="Title ParaOverride-1"><span class="CharOverride-1">Saint Sebastian</span></p>
<p class="body-text ParaOverride-2"><span class="CharOverride-2">Part of the Queering Consent series</span></p>
<p class="body-text ParaOverride-2"><span class="CharOverride-2">An excerpt from the forthcoming book </span><span class="CharOverride-3">Experience Points</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">N.A.Melamed</span></p>
<br/>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">This edition © Microcosm Publishing, 2021</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">eBook ISBN 9781648411465</span></p>
<br/>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">This is Microcosm #719</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">For a catalog, write or visit:</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">Microcosm Publishing</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">2752 N Williams Ave.</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">Portland, OR 97227</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">www.Microcosm.Pub</span></p>
<br/>
<p class="Normal ParaOverride-3"><span class="CharOverride-4">Did you know that you can buy our books directly from us at sliding scale rates? Support a small, independent publisher and pay less than Amazon’s price at </span><span class="CharOverride-4">www.</span><span class="CharOverride-5">Microcosm.Pub</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="uNnCb8XHBOLawAdaJEZJ2o4">
<img alt="" class="_idGenObjectAttribute-1" src="image/logostamp-black.png"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stsebastianepub.vue?fa7407d0